// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-48c87caa]{font-weight:400;font-size:20px;line-height:23px}", ""]);
// Exports
module.exports = exports;
